import { request } from '@utils/http'
import type {
  PriceFclPageRequest,
  PricePrePortPageRequest,
  PriceLastMilePageRequest,
  PriceLclPageRequest,
  PriceAirPageRequest
} from './sass/rate-query/types'
import type { PriceRailPageRequest } from './sass/rate-management/rail'
import type { RailSurchargePageRequest } from './sass/surcharge-management/rail'

/**
 * 价格导出请求VO
 * 用于MQ传递价格导出任务的基础信息
 */
export interface PriceExportRequestVO {
  /** 任务ID */
  taskId: string | null
  /** 用户ID */
  userId: string | null
  /** 租户ID */
  tenantId: string | null
  /** 企业ID */
  enterpriseId?: string | null
  /** 用户类型 */
  userType: number | null
  /** 角色类型 */
  roleType?: number | null
  /** 运价类型（1-FCL整箱，2-PRE_PORT港前，3-LAST_MILE尾程，4-LCL拼箱，5-AIR空运，7-Rail铁路，8-铁路附加费） */
  priceType: number
  /** 文件名 */
  fileName?: string | null
  /** 导出语言 */
  language?: string | null
  /** 导出字段列表 */
  headers?: string[] | null
  /** 整箱运价查询请求 */
  fclPageRequest?: PriceFclPageRequest | null
  /** 拼箱运价查询请求 */
  lclPageRequest?: PriceLclPageRequest | null
  /** 空运运价查询请求 */
  airPageRequest?: PriceAirPageRequest | null
  /** 港前运价查询请求 */
  prePortPageRequest?: PricePrePortPageRequest | null
  /** 尾程运价查询请求 */
  lastMilePageRequest?: PriceLastMilePageRequest | null
  /** 铁路运价查询请求 */
  railPageRequest?: PriceRailPageRequest | null
  /** 铁路附加费查询请求 */
  railSurchargePageRequest?: RailSurchargePageRequest | null
}

/**
 * 触发运价查询导出Excel任务
 * @param exportRequest 导出请求参数
 * @returns 是否成功触发
 */
export const triggerPriceExport = (exportRequest: PriceExportRequestVO) => {
  return request.post<boolean>('/mq/price-export/trigger', exportRequest)
}

/**
 * 订单列表查询请求（用于导出）
 */
export interface OrderExportPageRequest {
  pageNum: number
  pageSize: number
  conditions?: Array<{ fieldName: string; operator: string; value: any }>
  sorts?: any
}

/**
 * 订单导出请求VO
 */
export interface OrderExportRequestVO {
  /** 任务ID（后端创建，前端传null） */
  taskId?: string | null
  /** 用户ID */
  userId: string | null
  /** 租户ID */
  tenantId: string | null
  /** 企业ID */
  enterpriseId?: string | null
  /** 用户类型 */
  userType: number | null
  /** 角色类型 */
  roleType?: number | null
  /** 文件名 */
  fileName?: string | null
  /** 导出语言，zh-CN 中文 en-US 英文 */
  language?: string | null
  /** 导出字段列表（可见列的key数组） */
  headers?: string[] | null
  /** 订单查询请求（筛选条件+分页） */
  orderListRequest?: OrderExportPageRequest | null
}

/**
 * 触发订单导出Excel任务
 */
export const triggerOrderExport = (exportRequest: OrderExportRequestVO) => {
  return request.post<boolean>('/mq/order-export/trigger', exportRequest)
}
